var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M20 21H4V10H6V19H18V10H20V21ZM3 3H21V9H3V3ZM5 5V7H19V5M10.5 11V14H8L12 18L16 14H13.5V11"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }